var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsk20Dp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ask_20dp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "0103\\u66F4\\u65B0-live\\u5361\\u7247\\u53CA\\u53F3\\u4FA7\\u5C55\\u5F00\\u76F8\\u5173\\u6837\\u5F0F\\u66F4\\u65B0",
    transform: "translate(-970.000000, -246.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-28\\u5907\\u4EFD",
    transform: "translate(836.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-14",
    transform: "translate(30.000000, 209.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ask_20dp",
    transform: "translate(104.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "0 0 20 0 20 20 0 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,12.5 C9.725,12.5 14.1666667,13.6166667 14.1666667,15.8333333 L14.1666667,15.8333333 L14.1666667,17.5 L0.833333333,17.5 L0.833333333,15.8333333 C0.833333333,13.6166667 5.275,12.5 7.5,12.5 Z M16.725,1.66666667 C19.9833333,5.04166667 19.975,10.0916667 16.725,13.3333333 L16.725,13.3333333 L15.3666667,11.975 C17.675,9.325 17.675,5.54166667 15.3666667,3.025 L15.3666667,3.025 Z M7.5,4.16666667 C9.34094917,4.16666667 10.8333333,5.65905083 10.8333333,7.5 C10.8333333,9.34094917 9.34094917,10.8333333 7.5,10.8333333 C5.65905083,10.8333333 4.16666667,9.34094917 4.16666667,7.5 C4.16666667,5.65905083 5.65905083,4.16666667 7.5,4.16666667 Z M13.9666667,4.46666667 C15.65,6.3 15.65,8.84166667 13.9666667,10.525 L13.9666667,10.525 L12.5666667,9.11666667 C13.2666667,8.13333333 13.2666667,6.85833333 12.5666667,5.875 L12.5666667,5.875 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsk20Dp);
export default __webpack_public_path__ + "static/media/ask_20dp.8f8910317c059ab5d596e45897b9a46e.svg";
export { ForwardRef as ReactComponent };